import { useEffect, useState } from 'react';

const useNextRenderCall = (callback: Function): Function => {
    const [lock, setLock] = useState(false);
    useEffect(() => {
        if (lock) {
            callback();
            setLock(false);
        }
    }, [lock]);
    return () => setLock(true);
};

export default useNextRenderCall;
